<div class="container">
	<div class="modal-header">
		<h4 class="modal-title fw-bold">
			<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.study.title">Filter by Study</span>
		</h4>
		<button (click)="dismiss()" aria-hidden="true" class="btn-close" data-bs-dismiss="modal"
				type="button">
		</button>
	</div>
	<div class="modal-body">
		<div class="col-sm-6">
			<div class="input-group mb-3">
				<span class="input-group-text" id="filter-traits">
					<i class="fa fa-search"></i>
				</span>
				<input [(ngModel)]="studyFilterText" [placeholder]="traitFilterPlaceHolder" class="form-control"
					   id="textSearch" name="textSearch" type="text">
				<button (click)="studyFilterText=''" *ngIf="studyFilterText" aria-label="Clear" class="btn btn-outline-secondary">
					<i class="fa fa-times"></i>
				</button>
			</div>
		</div>
		<div class="row mt-2 mb-2">
			<div class="col-8">
				<div class="mb-3 d-flex align-items-center">
					<jhi-item-count [itemsPerPage]="traitStudies?.length" [page]="1" [total]="traitStudies?.length"></jhi-item-count>
                    <div class="p-2">
                        <span jhiTranslate="common.selected">Selected:</span>
                        <span class="fw-bold pl-2">
                            {{ selectedItems.size }}
                        </span>
                    </div>
					<span *ngIf="isLoading" class="throbber ml-2"></span>
				</div>
			</div>
		</div>
		<div class="table-responsive custom-scroll-style" style="height: 260px; overflow: auto">
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th><input (click)="onSelectPage()" [checked]="isPageSelected()"
                               [title]="'global.select.current.page' | translate" class="form-check-input"
							   data-test="selectCurrentPageCheckbox" [ngbTooltip]="'global.select.current.page' | translate"
							   type="checkbox"></th>
					<th>
						<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.study.table.header.name"></span>
					</th>
					<th>
						<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.study.table.header.description"></span>
					</th>
					<th>
						<span jhiTranslate="multi-trait-query.panel.specify.and.weight.the.environments.environment.filter.study.table.header.environments.no"></span>
					</th>
				</tr>
				</thead>
				<tbody *ngIf="traitStudies?.length else nodata">
				<tr *ngFor="let study of traitStudies | studyFilter:studyFilterText; trackBy: trackId; index as index">
					<td>
						<input (click)="toggleSelect($event, index, study, true); $event.stopPropagation()" [checked]="isSelected(study)" class="form-check-input"
							   type="checkbox">
					</td>
					<td>{{ study.name }}</td>
					<td>{{ study.description }}</td>
					<td>{{ study.numberOfEnvironments }}</td>
				</tr>
				</tbody>
			</table>
			<ng-template #nodata>
				<tbody>
				<tr>
					<td class="no-records" colspan="4" jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</ng-template>
		</div>
	</div>
	<div class="modal-footer">
		<div class="col-md-12 d-flex justify-content-center">
			<button (click)="apply()" [disabled]="!selectedItems.size" class="btn btn-primary ms-2" type="button">
				<span jhiTranslate="apply"></span>
			</button>
			<button (click)="reset()" class="btn btn-secondary ms-2" type="button">
				<span jhiTranslate="reset"></span></button>
		</div>
	</div>
</div>
